import * as React from 'react';
import * as ReactDOM from 'react-dom';
import oh from 'output-helpers';
import withConfig from 'with-config';

import default_config from './default_config';
import translations from './translations';

import MainView from './components/views/MainView';

import './index.css';
import StyledBase from './theme/StyledBase';

withConfig.setDefault(default_config);

oh.setConfig({
  lang: default_config.default_language
});

oh.addDictionary(translations);

ReactDOM.render(

  <StyledBase>
    <MainView />
  </StyledBase>,
  document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx